import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { checkLoggedUser, getUser } from '../../../redux/usersRedux';
import { useEffect } from 'react';
import { Box, Button, Divider } from '@mui/material';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import SpecificationListForm from '../../common/SpecificationListForm/SpecificationListForm';
import { deleteSpecificationRequest } from '../../../redux/specificationRedux';

const SpecificationList = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const user = useSelector((state) => getUser(state));
  useEffect(() => {
    const start = async () => {
      await dispatch(checkLoggedUser());
    };
    start();
  }, [dispatch]);

  const handleSubmit = async (id) => {
    await dispatch(deleteSpecificationRequest(id));
    console.log('Deleted specification with id:', id);
  };

  return (
    <Box>
      <h1>{t('masterData.specification.specificationList')}</h1>
      {user.users.role === 'ADMIN' && (
        <Button
          component={Link}
          to="/add-specification"
          sx={{ bgcolor: '#C09A53', ':hover': { bgcolor: '#9c7c43' } }}
          variant="contained"
          startIcon={<AddIcon />}
        >
          {t('masterData.specification.addButton')}
        </Button>
      )}

      <Divider sx={{ width: '100%', mb: 5, mt: 5, bgcolor: '#C09A53' }} />
      <SpecificationListForm action={handleSubmit} link="edit-specification" />
    </Box>
  );
};

export default SpecificationList;
